import { render, staticRenderFns } from "./AddEditInstruction.vue?vue&type=template&id=588e93e9"
import script from "./AddEditInstruction.vue?vue&type=script&lang=js"
export * from "./AddEditInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports